import Vuex from 'vuex';
import Vue from 'vue';

Vue.use(Vuex)

export default new Vuex.Store( {
    state () {
        return {
            city: '430100000000',
            config: {
            },
            incdata: 0
        }
    },
    mutations: {
        init (state, option) {
            state.config = option
        },
        byCity (state, city) {
            state.city = city
        },
        incdata (state, incdata) {
            state.incdata = incdata
        },
    },
    actions: {
        init (content, option) {
            content.commit('init', option)
        },
        byCity (content, city) {
            content.commit('byCity', city)
        },
        incdata (content, incdata) {
            content.commit('incdata', incdata)
        }
    }
})
